import * as types from './mutation-types'
export const getPostList = function ({commit, state}, {postlist, count}) {
  commit(types.SET_POSTLIST, postlist)
  commit(types.SET_COUNT, count)
}



// WEBPACK FOOTER //
// ./src/store/actions.js